import { render } from "./BackLayout.vue?vue&type=template&id=2b424bea"
import script from "./BackLayout.vue?vue&type=script&lang=js"
export * from "./BackLayout.vue?vue&type=script&lang=js"

import "./BackLayout.vue?vue&type=style&index=0&id=2b424bea&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__